import React from 'react'
import MyProfile from '../../Layout/Infomation'

const MyProfilePage = () => {
  return <MyProfile />
}
export default MyProfilePage
